// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto'
import '@babel/polyfill'
import Vue from 'vue'
import App from './App'
import store from './store2'
import router from './router'
import EdgeCheck from 'vue-edge-check'
import SwipeNaved from './plugin/SwipeNaved'
// import { getQueryParams } from './api/utils'
import '@/css/colors.css'
import dbPath from './db/brand_style_ref.csv'

Vue.config.productionTip = false

Vue.use(EdgeCheck)
Vue.use(SwipeNaved)

/* eslint-disable no-new */

store.dispatch('fetch', dbPath).then(() => {
  // store.commit('SET_ITEM', getQueryParams()['item'])
  new Vue({
    el: '#app',
    store,
    router,
    components: { App },
    template: '<App/>',
  })
}).catch(err => {
  console.log(err)
})



// WEBPACK FOOTER //
// ./src/main.js